import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { api } from "../../utils/api";
import Skeleton from "../common/loading/Skeleton";
import HomeHeroSlideCard from "./HomeHeroSlideCard";
import { heroSlideCardProps } from "./heroSlideDisplay";
import { heroSlidesForViewport } from "./heroSlidesForViewport";

export default function HeroSection({ isDesktop = true }) {
	const [slides, setSlides] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const viewport = isDesktop ? "desktop" : "mobile";

	useEffect(() => {
		setIsLoading(true);
		api
			.homeHeroSlides(viewport)
			.then((data) => setSlides(heroSlidesForViewport(data, viewport)))
			.catch(() => setSlides([]))
			.finally(() => setIsLoading(false));
	}, [viewport]);

	const count = slides.length;

	const swiperBg = `
		.hero-home-swiper,
		.hero-home-swiper.swiper,
		.hero-home-swiper .swiper-wrapper {
			background: transparent !important;
		}
		.hero-home-swiper .swiper-slide {
			background: transparent !important;
			overflow: hidden;
			box-sizing: border-box;
		}
		.hero-home-swiper .swiper-pagination {
			position: relative !important;
			margin-top: 12px;
		}
		.hero-home-swiper .swiper-pagination-bullet {
			width: 8px;
			height: 8px;
			background: #969BA1;
			opacity: 0.55;
		}
		.hero-home-swiper .swiper-pagination-bullet-active {
			width: 22px;
			border-radius: 999px;
			background: #276AA6;
			opacity: 1;
		}
	`;

	if (isLoading) {
		return (
			<section className="mx-auto w-full max-w-[1200px] px-4 pt-5">
				<Skeleton variant="banner" />
			</section>
		);
	}

	if (count === 0) {
		return null;
	}

	return (
		<section
			className="mx-auto w-full max-w-[1200px] px-4 pt-5"
			aria-label={count > 1 ? "اسلایدر صفحه اصلی" : "بنر صفحه اصلی"}
		>
			<style>{swiperBg}</style>
			{count === 1 ? (
				<HomeHeroSlideCard
					{...heroSlideCardProps(slides[0])}
					layout={viewport}
				/>
			) : (
				<Swiper
					dir="rtl"
					modules={[Autoplay, Pagination]}
					className="!w-full hero-home-swiper"
					loop={count > 1}
					slidesPerView={1}
					spaceBetween={0}
					pagination={{ clickable: true }}
					autoplay={{
						delay: 5000,
						disableOnInteraction: true,
					}}
				>
					{slides.map((slide) => (
						<SwiperSlide key={slide.id} className="!h-auto">
							<HomeHeroSlideCard
								{...heroSlideCardProps(slide)}
								layout={viewport}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			)}
		</section>
	);
}
